export const VIDEO_TEST_ID = 'video-callout-understanding'
export const PIPE_TEST_ID = 'pipe-between-links'
export const PDF_LINK_TEST_ID =
  'text-link-item-lesson-completion-snapshot-guide'
